// extracted by mini-css-extract-plugin
export var container = "ParkingAreas-module--container--KGVAf";
export var header = "ParkingAreas-module--header--bv716";
export var btn__add = "ParkingAreas-module--btn__add--xRIrA";
export var content = "ParkingAreas-module--content--m8Nnb";
export var loadMore = "ParkingAreas-module--loadMore--wCpej";